// ADR 3.10.26f §3 — the header's trailing slot: the plain gear, or the box of
// doors. Replaces 30.9.26s §4's `ConsoleSwitch` and 28.9.26e §7's gear.
//
// This component reads only the console's gate — `integrationsAdmit` over
// `useAdminFacts` and the session's `emailVerified`, exactly as
// `IntegrationsSection` does — so the box and the `/account` door never
// disagree. Not admitted (every learner, and everyone while the facts load):
// today's gear, byte for byte, with no trigger and no `[aria-expanded]`.
//
// The box is a component of its own, not a branch here: `useEscapeCloses`
// attaches in an effect keyed on the ref *objects*, so a component that first
// drew the gear and later the box would keep the same refs and leave Escape
// dead. `SwitcherBox` mounts with its wrapper in place. It is also what keeps
// `GET /settings/developer-tools` off every learner's page.
//
// `Header` is in the main bundle and `/admin`, `/connections` and `/account/*`
// are lazy, so nothing here imports a page (`lazyRoutes.test.tsx`).
//
// ADR 17.10.26i §5 — the gear is the `language_change` tour's first target,
// `header.settings`. `SwitcherBox`'s trigger carries the same id, so the
// target swaps with the element when the admin facts load.

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useAuthSession } from '../../auth/session'
import { integrationsAdmit } from '../../features/admin/sections'
import { useAdminFacts } from '../../features/admin/useAdminFacts'
import { useCoachAnchor } from '../../features/coach/anchors'
import { TOUR_ANCHORS } from '../../features/coach/tours/tourFlows'
import { IconButton } from '../../ui/controls'
import { SwitcherBox } from './SwitcherBox'

export function HeaderSwitcher() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { flags, emailVerified } = useAuthSession()
  const facts = useAdminFacts(flags)
  const anchor = useCoachAnchor<HTMLButtonElement>(TOUR_ANCHORS.headerSettings)
  if (!integrationsAdmit(facts, emailVerified)) {
    return <IconButton ref={anchor} icon="settings" label={t('settings_title')} onClick={() => navigate('/account')} />
  }
  return <SwitcherBox />
}
